export default __webpack_public_path__ + "static/media/poitrine.a7555b2b.jpg";